// dna_frontend/src/pages/AdminXacMinh.js
// (*** PHIÊN BẢN CẬP NHẬT: Cột "Trạng thái các Xã" hiển thị chi tiết với icon + màu sắc ***)

import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import './LietSiManagement.css'; // Sử dụng chung CSS
import './AdminUpload.css'; // Sử dụng chung CSS Upload

// --- Component Modal Sửa (Giữ nguyên) ---
const EditModal = ({ item, type, onClose, onSave }) => {
    const [formData, setFormData] = useState({});
    const [error, setError] = useState('');
    useEffect(() => {
        if (item) {
            setFormData({
                ho_ten: item.ho_ten,
                nam_sinh: item.nam_sinh,
                cccd: item.cccd,
                dia_chi: item.dia_chi || '',
                admin_ghi_chu: item.admin_ghi_chu || '',
                liet_si_info_goc: item.liet_si_info_goc || ''
            });
        }
    }, [item]);
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const apiUrl = type === 'chuaroxa' ? `/xacminh/chuaroxa/${item.id}` : `/xacminh/trunglap/${item.id}`;
            await api.put(apiUrl, formData);
            onSave();
            onClose();
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi khi lưu');
        }
    };
    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>Sửa thông tin Xác minh</h3>
                {error && <p className="modal-error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group"><label>Họ tên (*)</label><input type="text" name="ho_ten" value={formData.ho_ten} onChange={handleChange} /></div>
                    <div className="form-group"><label>Năm sinh (*)</label><input type="text" name="nam_sinh" value={formData.nam_sinh} onChange={handleChange} /></div>
                    <div className="form-group"><label>CCCD (*)</label><input type="text" name="cccd" value={formData.cccd} onChange={handleChange} /></div>
                    <div className="form-group"><label>Địa chỉ</label><input type="text" name="dia_chi" value={formData.dia_chi} onChange={handleChange} /></div>
                    {type === 'trunglap' && (
                        <div className="form-group"><label>Thông tin Liệt sĩ Gốc (Admin nhập)</label><textarea name="liet_si_info_goc" value={formData.liet_si_info_goc} onChange={handleChange}></textarea></div>
                    )}
                    <div className="form-group"><label>Ghi chú của Admin</label><textarea name="admin_ghi_chu" value={formData.admin_ghi_chu} onChange={handleChange}></textarea></div>
                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="btn-secondary">Hủy</button>
                        <button type="submit" className="btn-primary">Lưu</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// --- Component Modal Gán Xã (Giữ nguyên) ---
const AssignXaModal = ({ item, type, onClose, onSave, xaPhuongList }) => {
    const [assigned, setAssigned] = useState([]);
    const [selectedXaIds, setSelectedXaIds] = useState([]);
    const [error, setError] = useState('');
    const apiUrl = type === 'chuaroxa' ? `/xacminh/chuaroxa/${item.id}/xaphuong` : `/xacminh/trunglap/${item.id}/xaphuong`;
    useEffect(() => {
        const fetchAssigned = async () => {
            try {
                const res = await api.get(apiUrl);
                setAssigned(res.data);
            } catch (err) { console.error(err); }
        };
        fetchAssigned();
    }, [apiUrl]);
    const unassignedXaList = xaPhuongList.filter(
        xa => !assigned.find(a => a.xa_id === xa.id)
    );
    const handleSelect = (xaId) => {
        setSelectedXaIds(prev =>
            prev.includes(xaId) ? prev.filter(id => id !== xaId) : [...prev, xaId]
        );
    };
    const handleSubmit = async () => {
        setError('');
        if (selectedXaIds.length === 0) {
            setError('Vui lòng chọn ít nhất một xã để gán.');
            return;
        }
        try {
            await api.post(apiUrl, { xa_ids: selectedXaIds });
            onSave();
            onClose();
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi khi gán xã');
        }
    };
    const handleDeleteAssigned = async (mappingId) => {
        if (!window.confirm('Bạn có chắc muốn xóa xã này khỏi danh sách xác minh?')) return;
        try {
            await api.delete(`/xacminh/xaphuong-mapping/${type}/${mappingId}`);
            onSave(); 
            onClose(); 
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi khi xóa');
        }
    };
    return (
        <div className="modal-backdrop">
            <div className="modal-content" style={{ maxWidth: '700px' }}>
                <h3>Gán xã cho: {item.ho_ten}</h3>
                {error && <p className="modal-error">{error}</p>}
                <h4>Các xã đã gán</h4>
                <table className="crud-table">
                    <thead><tr><th>Tên xã</th><th>Trạng thái (Xã)</th><th>Ghi chú (Xã)</th><th>Hành động</th></tr></thead>
                    <tbody>
                        {assigned.length === 0 && <tr><td colSpan="4">Chưa gán xã nào</td></tr>}
                        {assigned.map(a => (
                            <tr key={a.id}>
                                <td>{a.ten_xa}</td>
                                <td>{a.xa_xac_nhan}</td>
                                <td>{a.xa_ghi_chu}</td>
                                <td><button className="btn-delete" onClick={() => handleDeleteAssigned(a.id)}>Xóa</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <hr style={{ margin: '20px 0' }} />
                <h4>Gán xã mới</h4>
                <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
                    {unassignedXaList.map(xa => (
                        <div key={xa.id} style={{ padding: '5px', borderBottom: '1px solid #eee' }}>
                            <input
                                type="checkbox"
                                id={`xa-${xa.id}`}
                                checked={selectedXaIds.includes(xa.id)}
                                onChange={() => handleSelect(xa.id)}
                            />
                            <label htmlFor={`xa-${xa.id}`} style={{ marginLeft: '10px' }}>{xa.ten_xa}</label>
                        </div>
                    ))}
                </div>
                <div className="modal-actions">
                    <button type="button" onClick={onClose} className="btn-secondary">Hủy</button>
                    <button type="button" onClick={handleSubmit} className="btn-primary">Gán ({selectedXaIds.length}) xã đã chọn</button>
                </div>
            </div>
        </div>
    );
};

// --- Component Modal Phê Duyệt (Giữ nguyên) ---
const ApproveModal = ({ item, type, onClose, onSave }) => {
    const [assigned, setAssigned] = useState([]);
    const [selectedMappingId, setSelectedMappingId] = useState(null);
    const [error, setError] = useState('');
    const adminUserId = JSON.parse(localStorage.getItem('user'))?.id; 
    const apiUrl = type === 'chuaroxa' ? `/xacminh/chuaroxa/${item.id}/xaphuong` : `/xacminh/trunglap/${item.id}/xaphuong`;
    useEffect(() => {
        const fetchAssigned = async () => {
            try {
                const res = await api.get(apiUrl);
                setAssigned(res.data.filter(a => a.xa_xac_nhan === 'xac_nhan' || a.xa_xac_nhan === 'da_xac_nhan'));
            } catch (err) { console.error(err); }
        };
        fetchAssigned();
    }, [apiUrl]);
    const handleSubmit = async () => {
        setError('');
        if (!selectedMappingId) {
            setError('Vui lòng chọn một xã đã xác nhận để phê duyệt.');
            return;
        }
        try {
            if (type === 'chuaroxa') {
                const selectedXaId = assigned.find(a => a.id === selectedMappingId)?.xa_id;
                await api.post('/xacminh/chuaroxa/approve', {
                    xacminh_id: item.id,
                    xa_id_duyet: selectedXaId,
                    user_id_admin: adminUserId
                });
            } else { // 'trunglap'
                await api.post('/xacminh/trunglap/approve', {
                    mapping_id: selectedMappingId,
                    user_id_admin: adminUserId
                });
            }
            onSave();
            onClose();
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi khi phê duyệt');
        }
    };
    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>Phê duyệt: {item.ho_ten}</h3>
                <p>Chọn một xã đã xác nhận để chuyển thân nhân này vào CSDL chính thức.</p>
                {error && <p className="modal-error">{error}</p>}
                <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
                    {assigned.length === 0 && <p style={{ padding: '10px' }}>Chưa có xã nào xác nhận.</p>}
                    {assigned.map(a => (
                        <div key={a.id} style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                            <input
                                type="radio"
                                name="approve-xa"
                                id={`map-${a.id}`}
                                onChange={() => setSelectedMappingId(a.id)}
                            />
                            <label htmlFor={`map-${a.id}`} style={{ marginLeft: '10px' }}>
                                <strong>{a.ten_xa}</strong> (Ghi chú: {a.xa_ghi_chu || 'Không'})
                            </label>
                        </div>
                    ))}
                </div>
                <div className="modal-actions">
                    <button type="button" onClick={onClose} className="btn-secondary">Hủy</button>
                    <button type="button" onClick={handleSubmit} className="btn-success" disabled={!selectedMappingId}>Phê duyệt</button>
                </div>
            </div>
        </div>
    );
};

// --- Helper render trạng thái xã (MỚI) ---
const renderAssignedXa = (infoString) => {
    if (!infoString) return <span style={{color: 'red', fontStyle: 'italic'}}>Chưa gán</span>;
   
    // Chuỗi dạng: "Xã A|xac_nhan;;Xã B|chua_phan_hoi;;Xã C|tu_choi"
    const items = infoString.split(';;');
   
    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '5px', fontSize: '0.9em'}}>
            {items.map((item, index) => {
                const [tenXa, status] = item.split('|');
                let color = 'gray';
                let textStatus = '(Chưa phản hồi)';
                let icon = '⏳';
                if (status === 'xac_nhan' || status === 'da_xac_nhan') {
                    color = 'green';
                    textStatus = '(ĐÃ XÁC NHẬN)';
                    icon = '✅';
                } else if (status === 'tu_choi') {
                    color = 'red';
                    textStatus = '(TỪ CHỐI)';
                    icon = '❌';
                }
                return (
                    <span key={index} style={{ color: color, fontWeight: status === 'xac_nhan' ? 'bold' : 'normal' }}>
                        {icon} <strong>{tenXa}</strong> {textStatus}
                    </span>
                );
            })}
        </div>
    );
};

// --- Component Trang Chính ---
function AdminXacMinh() {
    const [tab, setTab] = useState('chuaroxa'); 
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // State cho Bộ Lọc Trạng Thái
    const [statusFilter, setStatusFilter] = useState(''); 

    const [chuaRoXaList, setChuaRoXaList] = useState([]);
    const [trungLapList, setTrungLapList] = useState([]);
    const [xaPhuongList, setXaPhuongList] = useState([]);

    const [modal, setModal] = useState({ type: '', item: null }); 

    // State cho Upload
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadMessage, setUploadMessage] = useState('');

    // State cho Tìm kiếm TN Trùng lặp
    const [searchTerm, setSearchTerm] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedTnId, setSelectedTnId] = useState(null);
    const [addLoading, setAddLoading] = useState(false);

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const [crxRes, tlRes, xaRes] = await Promise.all([
                api.get('/xacminh/chuaroxa'),
                api.get('/xacminh/trunglap'),
                api.get('/data/xaphuong')
            ]);
            setChuaRoXaList(crxRes.data);
            setTrungLapList(tlRes.data);
            setXaPhuongList(xaRes.data);
        } catch (err) {
            setError('Lỗi tải dữ liệu');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleDelete = async (type, id) => {
        const item = type === 'chuaroxa' ? chuaRoXaList.find(i => i.id === id) : trungLapList.find(i => i.id === id);
        if (!window.confirm(`Bạn có chắc muốn xóa [${item.ho_ten}] khỏi danh sách tạm?`)) return;
        
        try {
            const apiUrl = type === 'chuaroxa' ? `/xacminh/chuaroxa/${id}` : `/xacminh/trunglap/${id}`;
            await api.delete(apiUrl);
            fetchData(); 
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi khi xóa');
        }
    };

    const handleSaveModal = () => {
        fetchData(); 
    };

    // Xử lý Upload "Chưa rõ xã"
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setUploadMessage('');
    };

    const handleUploadChuaRoXa = async () => {
        if (!file) {
            setUploadMessage('Vui lòng chọn file Excel.');
            return;
        }
        setUploading(true);
        setUploadMessage('');
        
        const formData = new FormData();
        formData.append('file', file);
        
        try {
            const res = await api.post('/data/upload-xacminh-chuaroxa', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setUploadMessage(`Thành công: ${res.data.message}`);
            setFile(null);
            document.getElementById('file-input-chuaroxa').value = null; 
            fetchData(); 
        } catch (err) {
            setUploadMessage(`Lỗi: ${err.response?.data?.message || 'Không thể upload file'}`);
        } finally {
            setUploading(false);
        }
    };

    // Xử lý Tìm kiếm TN
    const handleSearchTn = async () => {
        if (searchTerm.length < 3) {
            setSearchResults([]);
            return;
        }
        setSearchLoading(true);
        try {
            const res = await api.get(`/than-nhan/admin/search-basic`, { params: { ten_tn: searchTerm } });
            setSearchResults(res.data);
        } catch (err) {
            console.error("Lỗi tìm kiếm TN", err);
        } finally {
            setSearchLoading(false);
        }
    };
    
    // Xử lý Thêm TN Trùng lặp
    const handleAddTrungLap = async () => {
        if (!selectedTnId) {
            setError('Vui lòng chọn một thân nhân từ kết quả tìm kiếm.');
            return;
        }
        setAddLoading(true);
        setError('');
        try {
            const res = await api.post('/data/create-xacminh-trunglap', { than_nhan_id: selectedTnId });
            alert(res.data.message); 
            fetchData(); 
            setSearchTerm('');
            setSearchResults([]);
            setSelectedTnId(null);
        } catch (err) {
             setError(err.response?.data?.message || 'Lỗi khi thêm nhiệm vụ');
        } finally {
            setAddLoading(false);
        }
    };

    const renderTable = (type) => {
        let data = type === 'chuaroxa' ? chuaRoXaList : trungLapList;
        
        if (statusFilter) {
            data = data.filter(item => item.status === statusFilter);
        }

        return (
            <div className="table-wrapper">
                {/* Dropdown lọc trạng thái */}
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <label style={{ fontWeight: 'bold' }}>Lọc theo trạng thái:</label>
                    <select 
                        value={statusFilter} 
                        onChange={(e) => setStatusFilter(e.target.value)}
                        style={{ padding: '5px' }}
                    >
                        <option value="">-- Tất cả --</option>
                        <option value="cho_xac_minh">Chờ xã xác minh (Mới tạo/Đang chờ)</option>
                        <option value="cho_phe_duyet">Chờ Admin phê duyệt (Xã đã xác nhận)</option>
                        <option value="da_phe_duyet">Đã phê duyệt (Hoàn thành)</option>
                    </select>
                </div>

                <table className="crud-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Họ tên</th>
                            <th>Năm sinh</th>
                            <th>CCCD</th>
                            <th>Địa chỉ</th>
                            {type === 'trunglap' && <th>Thông tin LS Gốc</th>}
                            <th>Ghi chú Admin</th>
                            <th>Trạng thái các Xã</th>
                            <th>Trạng thái Hồ sơ</th>
                            <th>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 && <tr><td colSpan="10">Không có dữ liệu (phù hợp bộ lọc)</td></tr>}
                        {data.map(item => (
                            <tr key={item.id} style={{ background: item.status === 'da_phe_duyet' ? '#e8f5e9' : (item.status === 'cho_phe_duyet' ? '#fff9c4' : 'none') }}>
                                <td>{item.id}</td>
                                <td>{item.ho_ten}</td>
                                <td>{item.nam_sinh}</td>
                                <td>{item.cccd}</td>
                                <td>{item.dia_chi}</td>
                                {type === 'trunglap' && <td style={{whiteSpace: 'pre-wrap', fontSize: '0.9em'}}>{item.liet_si_info_goc}</td>}
                                <td style={{whiteSpace: 'pre-wrap'}}>{item.admin_ghi_chu}</td>
                                
                                {/* Hiển thị chi tiết trạng thái từng xã */}
                                <td style={{maxWidth: '250px'}}>
                                    {renderAssignedXa(item.assigned_xa_info)}
                                </td>
                                
                                <td>
                                    {item.status === 'da_phe_duyet' && <span style={{color: 'green', fontWeight: 'bold'}}>Đã xong</span>}
                                    {item.status === 'cho_phe_duyet' && <span style={{color: '#d4a017', fontWeight: 'bold'}}>Chờ duyệt (Xã OK)</span>}
                                    {item.status === 'cho_xac_minh' && <span style={{color: 'gray'}}>Đang chờ xã</span>}
                                </td>
                                <td className="actions-cell">
                                    <button className="btn-edit" onClick={() => setModal({ type: 'edit', item, listType: type })}>Sửa</button>
                                    <button className="btn-secondary" onClick={() => setModal({ type: 'assign', item, listType: type })}>Gán Xã</button>
                                    <button className="btn-success" onClick={() => setModal({ type: 'approve', item, listType: type })}>Phê Duyệt</button>
                                    <button className="btn-delete" onClick={() => handleDelete(type, item.id)}>Xóa</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className="liet-si-container">
            <h1>Admin - Quản lý Xác minh</h1>
            {error && <p className="error-message">{error}</p>}
            
            <p><strong>Hướng dẫn:</strong><br/>
            1. (Chưa rõ xã): Upload file Excel chứa DS thân nhân (cột: ho_ten, nam_sinh, cccd, dia_chi, admin_ghi_chu).<br/>
            2. (Trùng lặp): Tìm kiếm thân nhân đã có trong CSDL chính, chọn và "Tạo nhiệm vụ".<br/>
            3. (Chung): Dùng nút "Gán Xã" để giao nhiệm vụ. Khi xã xác nhận (trạng thái: 'Chờ duyệt'), dùng nút "Phê Duyệt".
            </p>

            <div className="tabs">
                <button onClick={() => setTab('chuaroxa')} className={tab === 'chuaroxa' ? 'active' : ''}>
                    Xác minh Thân nhân Chưa rõ xã ({chuaRoXaList.length})
                </button>
                <button onClick={() => setTab('trunglap')} className={tab === 'trunglap' ? 'active' : ''}>
                    Xác minh Thân nhân Trùng lặp ({trungLapList.length})
                </button>
            </div>

            {loading && <p>Đang tải dữ liệu...</p>}
            
            {/* Tab Chưa rõ Xã */}
            {tab === 'chuaroxa' && (
                <div className="list-section">
                    <div className="upload-section" style={{border: '1px solid #ccc', padding: '15px', borderRadius: '5px', marginBottom: '20px'}}>
                        <h4>Upload DS Thân nhân Chưa rõ xã (Excel)</h4>
                        <div className="form-group">
                            <input type="file" id="file-input-chuaroxa" onChange={handleFileChange} accept=".xlsx, .xls" />
                        </div>
                        <button onClick={handleUploadChuaRoXa} disabled={uploading} className="btn-primary">
                            {uploading ? 'Đang tải lên...' : 'Upload File'}
                        </button>
                        {uploadMessage && <p style={{ color: uploadMessage.startsWith('Lỗi') ? 'red' : 'green' }}>{uploadMessage}</p>}
                    </div>
                    {renderTable('chuaroxa')}
                </div>
            )}
            
            {/* Tab Trùng lặp */}
            {tab === 'trunglap' && (
                 <div className="list-section">
                    <div className="upload-section" style={{border: '1px solid #ccc', padding: '15px', borderRadius: '5px', marginBottom: '20px'}}>
                        <h4>Tạo nhiệm vụ Trùng lặp (từ CSDL)</h4>
                        <div className="form-group">
                            <input 
                                type="text" 
                                value={searchTerm} 
                                onChange={(e) => setSearchTerm(e.target.value)} 
                                placeholder="Tìm họ tên thân nhân trong CSDL..." 
                            />
                            <button onClick={handleSearchTn} className="btn-secondary" disabled={searchLoading}>
                                {searchLoading ? 'Đang tìm...' : 'Tìm'}
                            </button>
                        </div>
                        <div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #ccc' }}>
                            {searchResults.map(tn => (
                                <div key={tn.id} style={{ padding: '5px', borderBottom: '1px solid #eee' }}>
                                    <input 
                                        type="radio" 
                                        name="selected-tn" 
                                        id={`tn-${tn.id}`} 
                                        onChange={() => setSelectedTnId(tn.id)}
                                    />
                                    <label htmlFor={`tn-${tn.id}`} style={{ marginLeft: '10px' }}>
                                        {tn.ho_ten} ({tn.nam_sinh}) - {tn.dia_chi} (Xã: {tn.ten_xa})
                                    </label>
                                </div>
                            ))}
                        </div>
                        <button onClick={handleAddTrungLap} disabled={!selectedTnId || addLoading} className="btn-primary" style={{marginTop: '10px'}}>
                            {addLoading ? 'Đang tạo...' : 'Tạo Nhiệm vụ Trùng lặp'}
                        </button>
                    </div>
                    {renderTable('trunglap')}
                </div>
            )}

            {/* --- Modals --- */}
            {modal.type === 'edit' && (
                <EditModal
                    item={modal.item}
                    type={modal.listType}
                    onClose={() => setModal({ type: '', item: null })}
                    onSave={handleSaveModal}
                />
            )}
            {modal.type === 'assign' && (
                <AssignXaModal
                    item={modal.item}
                    type={modal.listType}
                    onClose={() => setModal({ type: '', item: null })}
                    onSave={handleSaveModal}
                    xaPhuongList={xaPhuongList}
                />
            )}
             {modal.type === 'approve' && (
                <ApproveModal
                    item={modal.item}
                    type={modal.listType}
                    onClose={() => setModal({ type: '', item: null })}
                    onSave={handleSaveModal}
                />
            )}
        </div>
    );
}

export default AdminXacMinh;